// extracted by mini-css-extract-plugin
module.exports = {"infoDocument":"itemdocument_infoDocument__tR2on","titol":"itemdocument_titol__UwNqM","entradeta":"itemdocument_entradeta__RwOeF","cos":"itemdocument_cos__nZrti"};